import { Link } from 'react-router-dom';
import styles from './SetupPageLayout.module.css';

function SetupPageLayout({ 
    stepNumber, 
    totalSteps, 
    title, 
    description, 
    onPrevious, 
    onNext, 
    nextDisabled = false, 
    nextLabel = 'Next',
    previousLabel,
    showHeaderNavigation = true,
    backLink = '/admin/setup',
    backLinkText = 'Roadmap',
    hideBackLink = false,
    children 
}) {
    const progress = (stepNumber / totalSteps) * 100;

    const handleNext = () => {
        if (!nextDisabled && onNext) {
            onNext();
        }
    };

    const handlePrevious = () => {
        if (onPrevious) {
            onPrevious();
        }
    };

    const previousButtonText = previousLabel 
        ? `← Previous: ${previousLabel}`
        : '← Previous';

    return (
        <div className={styles.setupPageContainer}>
            <header className={styles.setupHeader}>
                <div className={styles.headerContent}>
                    <div className={styles.stepIndicator}>
                        <div className={styles.stepIndicatorTop}>
                            {showHeaderNavigation && (
                                <button 
                                    onClick={handlePrevious} 
                                    disabled={stepNumber === 1 && !onPrevious}
                                    className={styles.navButton}
                                >
                                    {previousButtonText}
                                </button>
                            )}
                            <div className={styles.stepIndicatorCenter}>
                                {hideBackLink ? (
                                    <span className={styles.roadmapLink}>{backLinkText}</span>
                                ) : (
                                    <Link to={backLink} className={styles.roadmapLink}>
                                        {backLinkText}
                                    </Link>
                                )}
                                <div className={styles.stepIndicatorStatus}>
                                    <strong>Step {stepNumber} of {totalSteps}:</strong> {title}
                                </div>
                            </div>
                            {showHeaderNavigation && (
                                <button 
                                    onClick={handleNext} 
                                    disabled={nextDisabled}
                                    className={styles.navButton}
                                >
                                    {nextLabel} →
                                </button>
                            )}
                        </div>
                        <div className={styles.stepIndicatorProgress}>
                            <div className={styles.progressBar}>
                                <div 
                                    className={styles.progressFill}
                                    style={{ width: `${progress}%` }} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            
            <div className={styles.setupContent}>
                {description && (
                    typeof description === 'string' ? (
                        <p className={styles.description}>{description}</p>
                    ) : (
                        <div className={styles.description}>{description}</div>
                    )
                )}
                {children}
            </div>
        </div>
    );
}

export default SetupPageLayout;
